import { useState } from "react";
import { faqs } from "@/mocks/profile";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[360px_1fr] gap-8 lg:gap-12">
          <div>
            <p className="font-label text-primary-600 text-xs tracking-[0.25em] mb-3">FAQ / 问答</p>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
              最常见的六个问题
            </h2>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              这些问题几乎出现在每条相关讨论下面。答案尽量给出判断方法，而不只是结论，方便你之后自己辨别新信息。
            </p>
            <div className="mt-6 w-full h-40 rounded-lg overflow-hidden border border-background-200 hidden lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20minimal%20illustration%20of%20question%20and%20answer%20bubbles%20in%20warm%20rose%20terracotta%20and%20cream%20palette%2C%20abstract%20artistic%20graphic%20texture%2C%20calm%20editorial%20mood%2C%20no%20readable%20text&width=800&height=520&seq=saeko-faq-01&orientation=landscape"
                alt=""
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  key={item.q}
                  className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
                >
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? null : idx)}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`w-7 h-7 flex items-center justify-center rounded-md font-label text-xs ${
                            isOpen
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                        <span className="font-heading font-bold text-foreground-950 text-base md:text-lg">
                          {item.q}
                        </span>
                      </span>
                      <i
                        className={`text-xl text-foreground-500 transition-transform duration-300 ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 md:px-6 pb-5 md:pb-6 pl-[60px] md:pl-[68px]">
                      <p className="text-foreground-700 text-sm md:text-[15px] leading-relaxed">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}